export default function roleColor(role) {
  switch (role.toLowerCase()) {
    case 'def':
      return 'rgba(127, 255, 212, 0.5)'
    case 'atk':
      return 'rgba(255, 99, 71, 0.5)'
  }
}
